import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '../../utils/cn';
import { getStatusBadgeConfig } from '../statusBadge.config';

export interface StatusBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  status: string | null | undefined;
  label?: string;
  showDot?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  label,
  showDot = false,
  className,
  children,
  ...props
}) => {
  if (!status && !label && !children) {
    return null;
  }

  const config = getStatusBadgeConfig(status, label);
  const content = children ?? config.label;

  return (
    <Badge
      variant="outline"
      className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold', config.className, className)}
      {...props}
    >
      {showDot && <span className={cn('h-1.5 w-1.5 rounded-full flex-shrink-0', config.dotClassName)} />}
      {content}
    </Badge>
  );
};

export default StatusBadge;
